import React from "react";
import { Modal } from "react-bootstrap";

interface CouponModalProps {
  onClose: (success: any) => void;
  shouldShow: boolean;
  image: any;
}

export default function CouponModal({ onClose, shouldShow, image }: CouponModalProps) {
  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body>
          <div className="modal-body">
            <img src={image} style={{ width: "100%" }} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4">
              <a
                href={image}
                download
                // onClick={onClose}
                target="_blank"
              >
                Download
              </a>
            </button>
          </div>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={onClose}>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
